import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2, Send } from 'lucide-react';
import { Button } from '../ui';
import { ApiError } from '../../services/api/apiClient';

interface Props {
  submitted: boolean;
  onSubmit: () => Promise<void>;
}

export function BecasSubmitPanel({ submitted, onSubmit }: Props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (submitted) {
    return (
      <div className="text-center py-8 space-y-4">
        <CheckCircle2 className="w-14 h-14 text-green-400 mx-auto" />
        <h3 className="text-2xl font-black text-white">{t('becas.success.title')}</h3>
        <p className="text-dark-400">{t('becas.success.body')}</p>
        <Button variant="outline" onClick={() => { window.location.href = '/'; }}>
          {t('becas.success.home')}
        </Button>
      </div>
    );
  }

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    try {
      await onSubmit();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : t('becas.errors.generic'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-5">
      <p className="text-dark-300 leading-relaxed">{t('becas.submit.intro')}</p>
      {error && (
        <p className="text-sm text-accent-rose bg-accent-rose/10 border border-accent-rose/30 rounded-xl px-4 py-3">
          {error}
        </p>
      )}
      <Button
        type="button"
        variant="primary"
        fullWidth
        isLoading={loading}
        icon={<Send className="w-5 h-5" />}
        onClick={() => void handleSubmit()}
      >
        {t('becas.submit.cta')}
      </Button>
    </div>
  );
}
